class AddOn extends window.BAO.CustomElement() {
  constructor () {
    super()

    if (!this.id) {
      throw new Error(`Please provide a unique id for this add on`)
    }
  }

  setupListeners () {
    this.beforeCartAdd = this.beforeCartAdd.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD,
      this.beforeCartAdd
    )
  }

  beforeCartAdd ({ detail: { attributes, form } }) {
    if (form === this.form) {
      attributes[`Add On - ${this.id}`] = 'claimed'
    }
  }

  get form () {
    return this.querySelector('form')
  }

  get variantId () {
    return parseInt(this.getAttribute('variant-id'), 10)
  }
}

class ClipOnAddOn extends AddOn {
  setupListeners () {
    super.setupListeners()

    this.handleSelectChange = this.handleSelectChange.bind(this)

    if (this.els?.select?.exists) {
      this.listeners.add(
        this.els.select.element,
        'change',
        this.handleSelectChange
      )
    }
  }

  handleSelectChange (e) {
    this.isSubmittable = !!e.target.value
  }

  get isSubmittable () {
    return this._isSubmittable
  }

  set isSubmittable (val) {
    this._isSubmittable = val

    if (this.els?.submit?.exists) {
      this.els.submit.element.disabled = !val
    }
  }
}

if (!customElements.get('add-on')) {
  customElements.define('add-on', AddOn)
}

if (!customElements.get('clip-on-add-on')) {
  customElements.define('clip-on-add-on', ClipOnAddOn)
}
